"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : MENU : FILTER : STYLES --------------- ++++++++++ */


var _default = {
  filtermenu: {
    position: 'relative',
    // needed so the menu is relative to this indicator only
    height: (0, _index.pxToEm)(56),
    '& .name-filters': {
      background: 'white !important',
      '&.menuOpen-true': {
        borderColor: 'rgb(20, 148, 244)'
      }
    },
    '& .menuitems': {
      transition: 'all .05s ease-out 0s'
    },
    // ----- states ----- //
    '&.active-true': {
      '& .menuitems': {
        opacity: '1',
        transform: 'translateX(0%) scale(1)',
        zIndex: '2'
      }
    },
    '&.active-false': {
      '& .menuitems': {
        opacity: '0',
        transform: 'translateX(0%) scale(0)',
        zIndex: '-1'
      }
    },
    '& .dropdownindicator': {
      maxWidth: (0, _index.pxToEm)(230),
      '& .title': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }
  }
};
exports.default = _default;